import type { DeviceConnectionStatus } from './deviceConnectionStatus.model';
import type { DeviceBaseInfo } from './deviceMetrics.model';
import type { RemoteDesktopStatus } from './remoteDesktop.model';

export type NonRequiredDeviceConnectionStatus = Partial<
  Pick<DeviceConnectionStatus, 'connectionStatus' | 'timestamp'>
> &
  Required<Pick<DeviceConnectionStatus, 'id' | 'isConnected'>>;

export declare const deviceConnectionStatus: {
  readonly CONNECTED: 'CONNECTED';
  readonly DISCONNECTED: 'DISCONNECTED';
  readonly NEVER_CONNECTED: 'NEVER_CONNECTED';
};
export type DeviceConnectionStatusEnum = (typeof deviceConnectionStatus)[keyof typeof deviceConnectionStatus];

export declare const enumScreenLockingStatus: {
  readonly LOCKED: 'LOCKED';
  readonly LOCKING: 'LOCKING';
  readonly UNLOCKED: 'UNLOCKED';
  readonly UNLOCKING: 'UNLOCKING';
};
export type EnumScreenLockingStatus = (typeof enumScreenLockingStatus)[keyof typeof enumScreenLockingStatus];

export interface DeviceCallSchedulingTime {
  readonly hour?: number;
  readonly minute?: number;
  readonly hours?: number;
  readonly minutes?: number;
}

export interface DeviceCallScheduling {
  readonly callFrequency?: number;
  readonly endTimeWindow?: string;
  readonly nextCallDate?: string;
  readonly retryPeriod?: number;
  readonly startTimeWindow?: string;
}

export interface DeviceInfo {
  readonly id: string;
  readonly baseInfo: DeviceBaseInfo;
  readonly connection: NonRequiredDeviceConnectionStatus;
  readonly callScheduling?: DeviceCallScheduling;
  readonly remoteDesktopStatus: RemoteDesktopStatus;
  readonly isRtsEnabled: boolean;
  readonly isLogcatReady: boolean;
  readonly connectionStatus?: DeviceConnectionStatusEnum;
  readonly screenLockingStatus?: EnumScreenLockingStatus;
}
